import axios from "axios";
import {authHeader} from './auth-header';

const API_URL = process.env.REACT_APP_API_URL || '/api/';

const createFunerioFuneral = (funeralId) => axios.post(
    `${API_URL}funeral/${encodeURIComponent(funeralId)}/share/funus`, {}, {headers: authHeader()});

// eslint-disable-next-line import/no-anonymous-default-export
export default {
    createFunerioFuneral
};
